import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen bg-black text-white font-sans" data-id="element-67" data-mp="qab9n89x20sw">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-16 sm:py-24" data-id="element-68" data-mp="qcwbvye4mir6">
        <Link to="/" className="inline-flex items-center gap-2 text-sm tracking-wide text-white/70 hover:text-brand-gold transition-colors duration-300 mb-12" data-id="element-69" data-mp="mbaubzqndgan">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-70" data-mp="1e17a0tsfu4br" />
          Back to pollockventures.com
        </Link>

        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light tracking-tight mb-2" data-id="element-71" data-mp="198e442l8gpy3">
          Privacy Policy
        </h1>
        <p className="text-sm text-white/50 mb-12" data-id="element-72" data-mp="21q89hrjam54w">
          Effective Date: May 2, 2026
        </p>

        <div className="space-y-8 text-white/80 leading-relaxed text-base" data-id="element-73" data-mp="1wzjl4l2wto9z">
          <p data-id="element-74" data-mp="1wxf7vcj4fcx1">
            Pollock Venture Partners, LLC ("Company," "we," "us," or "our")
            operates the website www.pollockventures.com (the "Site"). This
            Privacy Policy explains how we collect, use, and protect your
            information.
          </p>

          <Section title="1. Information We Collect" data-id="element-75" data-mp="3rg2kkcdrijmg">
            <p data-id="element-76" data-mp="9st41ygu2kv">We may collect the following types of information:</p>
            <h3 className="text-white font-medium mt-4 mb-2" data-id="element-77" data-mp="7y6mj7jq2eo">
              a. Information You Provide
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-78" data-mp="3nequy6uw1ye9">
              <li data-id="element-79" data-mp="3nglcrcav5ae4">
                Name, email address, or other details you submit via contact
                forms or email
              </li>
            </ul>
            <h3 className="text-white font-medium mt-4 mb-2" data-id="element-80" data-mp="3dg1aq7fis1uu">
              b. Automatically Collected Information
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-81" data-mp="16qweoqkqebvn">
              <li data-id="element-82" data-mp="1bpzm2ho6ou6s">IP address</li>
              <li data-id="element-83" data-mp="1bo6ft3hhgbzb">Browser type and device information</li>
              <li data-id="element-84" data-mp="1a80zw0lk665g">Pages visited and time spent on the Site</li>
              <li data-id="element-85" data-mp="1a9lq5e0ub2xi">Cookies and similar tracking technologies</li>
            </ul>
          </Section>

          <Section title="2. How We Use Your Information" data-id="element-86" data-mp="157wim8ctt7e6">
            <p data-id="element-87" data-mp="10b60zgldi3qn">We use information to:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-88" data-mp="10c7dlpi1eyah">
              <li data-id="element-89" data-mp="w9ktybvisjod">Operate and maintain the Site</li>
              <li data-id="element-90" data-mp="wavwy9h55nef">Respond to inquiries or communications</li>
              <li data-id="element-91" data-mp="1sxh34vomocpk">Improve site performance and user experience</li>
              <li data-id="element-92" data-mp="1nz76egn9941u">Monitor usage and analytics</li>
            </ul>
          </Section>

          <Section title="3. Cookies and Tracking" data-id="element-93" data-mp="1j8qqmpvyp6cb">
            <p data-id="element-94" data-mp="1j7fo0te964ms">We may use cookies or similar technologies to:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-95" data-mp="1f86v1qr1easa">
              <li data-id="element-96" data-mp="1f5kmbnsetp8h">Understand user behavior</li>
              <li data-id="element-97" data-mp="2bqbgxmailys7">Improve functionality</li>
              <li data-id="element-98" data-mp="2bre7tu7u8184">Analyze traffic (e.g., via analytics tools)</li>
            </ul>
            <p className="mt-3" data-id="element-99" data-mp="26x9zb6ixbl4x">
              You can control cookies through your browser settings.
            </p>
          </Section>

          <Section title="4. Sharing of Information" data-id="element-100" data-mp="3uke8e4fov3hs">
            <p data-id="element-101" data-mp="3ukxt1swq45zi">We do not sell your personal information.</p>
            <p className="mt-3" data-id="element-102" data-mp="2g3pjvf2sutq">We may share information with:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-103" data-mp="2iyb5q9tsloq">
              <li data-id="element-104" data-mp="7ghmahb88icg">Service providers (e.g., analytics tools)</li>
              <li data-id="element-105" data-mp="cf1e2yci4ocq">Legal authorities if required by law</li>
            </ul>
          </Section>

          <Section title="5. Your Rights" data-id="element-106" data-mp="hdmeoyvo1a1p">
            <p data-id="element-107" data-mp="hcb9cumknu8h">
              Depending on your location (including California), you may have
              rights to:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-108" data-mp="m6yqg8f8xmd1">
              <li data-id="element-109" data-mp="q4wgfdgucchh">Request access to your data</li>
              <li data-id="element-110" data-mp="v5akkkfbn2a8">Request deletion of your data</li>
              <li data-id="element-111" data-mp="v6u54n80fzht">Opt out of certain data uses</li>
            </ul>
            <p className="mt-3" data-id="element-112" data-mp="103u7oo5nik46">
              To exercise these rights, contact us at:{' '}
              <a href="mailto:legal@pollockventures.com" className="text-brand-gold hover:underline" data-id="element-113" data-mp="mh4zl76bomg9">
                legal@pollockventures.com
              </a>
            </p>
          </Section>

          <Section title="6. Data Security" data-id="element-114" data-mp="w6wuy3m8xjls">
            <p data-id="element-115" data-mp="r8n4u7fdp971">
              We take reasonable measures to protect your information, but no
              system is completely secure.
            </p>
          </Section>

          <Section title="7. Third-Party Links" data-id="element-116" data-mp="3klzf7dhy8vu">
            <p data-id="element-117" data-mp="3uq59y73ro23r">
              The Site may contain links to third-party websites. We are not
              responsible for their privacy practices.
            </p>
          </Section>

          <Section title="8. Changes to This Policy" data-id="element-118" data-mp="8hcdjp5qquem">
            <p data-id="element-119" data-mp="8jykbmkt55vs">
              We may update this Privacy Policy from time to time. Updates will
              be posted on this page with a revised effective date.
            </p>
          </Section>

          <Section title="9. Contact Information" data-id="element-120" data-mp="1jz54eygw8sfp">
            <p data-id="element-121" data-mp="1rga947jofo3f">Pollock Venture Partners, LLC</p>
            <p data-id="element-122" data-mp="1rimsmp5326il">16192 Coastal Highway</p>
            <p data-id="element-123" data-mp="1wg663mtyif9h">Lewes, DE 19958</p>
            <p className="mt-3" data-id="element-124" data-mp="1wh7rol8lmk5g">
              Email:{' '}
              <a href="mailto:legal@pollockventures.com" className="text-brand-gold hover:underline" data-id="element-125" data-mp="1igdg5tq9832k">
                legal@pollockventures.com
              </a>
            </p>
          </Section>
        </div>
      </div>
    </main>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-126" data-mp="21ezifbxic082">
      <h2 className="font-heading text-xl sm:text-2xl font-light tracking-tight text-white mb-3" data-id="element-127" data-mp="21f9bj8dumnhz">
        {title}
      </h2>
      <div className="space-y-2" data-id="element-128" data-mp="25f085sq23xuf">{children}</div>
    </section>;
}